import { compact } from 'lodash'

import {
  ADD_PROJECT,
  CHANGE_COMPETITOR_TRACKING_LOCATION,
  CHANGE_CURRENT_PROJECT,
  DELETE_PROJECT,
  FETCH_PROJECTS,
  GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT,
  RELOAD_PROJECT,
  UPDATE_PROJECT,
} from './actions'

const initialState = {
  projects: null,
  currentProject: null,
  isLoadingProjectLimits: false,
  isLoadingProjects: false,
  isUpdatingProject: false,
  competitorTracking: {
    isLoadingCompetitors: true,
    locId: null,
    lang: null,
    domains: [],
    reportId: undefined,
    competitors: undefined,
    competitorsData: undefined,
    noData: false,
    isAdding: false,
    isDeleting: false,
  },
}

const dashboardReducer = (state = initialState, action = {}) => {
  let resultState = null
  switch (action.type) {
    case FETCH_PROJECTS.action:
      resultState = {
        ...state,
        isLoadingProjects: true,
      }
      break
    case FETCH_PROJECTS.success:
      resultState = {
        ...state,
        ...action.payload,
        isLoadingProjects: false,
      }
      break
    case RELOAD_PROJECT.success:
      resultState = {
        ...state,
        ...action.payload,
      }
      break
    case CHANGE_CURRENT_PROJECT.action: {
      const currentProject = state.projects.find(
        (p) => p.id === action.projectId,
      )

      const locations = compact([
        currentProject.competitors_locations[0],
        currentProject.locations[0],
      ])
      const { loc_id, lang } = locations[0] || {}

      resultState = {
        ...state,
        currentProject,
        competitorTracking: {
          isLoadingCompetitors: false,
          locId: loc_id,
          lang,
          domains: [],
          reportId: undefined,
          competitors: undefined,
          competitorsData: undefined,
          noData: false,
          isAdding: false,
          isDeleting: false,
        },
      }
      break
    }
    case DELETE_PROJECT.action:
      resultState = {
        ...state,
        isUpdatingProject: true,
      }
      break
    case DELETE_PROJECT.success: {
      const { currentProject, projects } = action.payload
      const locations = currentProject
        ? compact([
            currentProject.competitors_locations[0],
            currentProject.locations[0],
          ])
        : []
      resultState = {
        ...state,
        currentProject,
        projects,
        competitorTracking: {
          isLoadingCompetitors: true,
          locId: locations[0]?.loc_id,
          lang: locations[0]?.lang,
          domains: [],
          reportId: undefined,
          competitors: undefined,
          competitorsData: undefined,
          noData: false,
          isAdding: false,
          isDeleting: false,
        },
        isUpdatingProject: false,
      }
      break
    }
    case DELETE_PROJECT.failed:
      resultState = {
        ...state,
        isUpdatingProject: false,
      }
      break
    case ADD_PROJECT.action:
      resultState = {
        ...state,
        isUpdatingProject: true,
      }
      break
    case ADD_PROJECT.success: {
      const { currentProject, projects } = action.payload
      const locations = compact([
        currentProject.competitors_locations[0],
        currentProject.locations[0],
      ])

      resultState = {
        ...state,
        currentProject,
        projects,
        competitorTracking: {
          isLoadingCompetitors: true,
          locId: locations[0]?.loc_id,
          lang: locations[0]?.lang,
          domains: [],
          reportId: undefined,
          competitors: undefined,
          competitorsData: undefined,
          noData: false,
          isAdding: false,
          isDeleting: false,
        },
        isUpdatingProject: false,
      }
      break
    }
    case ADD_PROJECT.failed:
      resultState = {
        ...state,
        isUpdatingProject: false,
      }
      break
    case UPDATE_PROJECT.action:
      resultState = {
        ...state,
        isUpdatingProject: true,
      }
      break
    case UPDATE_PROJECT.success:
      resultState = {
        ...state,
        ...action.payload,
        isUpdatingProject: false,
      }
      break
    case UPDATE_PROJECT.failed:
      resultState = {
        ...state,
        isUpdatingProject: false,
      }
      break
    case CHANGE_COMPETITOR_TRACKING_LOCATION.action:
      resultState = {
        ...state,
        competitorTracking: {
          ...state.competitorTracking,
          ...action.payload,
          isLoadingCompetitors: true,
          noData: false,
        },
      }
      break
    case GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.action:
      resultState = {
        ...state,
        competitorTracking: {
          ...state.competitorTracking,
          locId: action.payload.locId,
          lang: action.payload.lang,
          isLoadingCompetitors: true,
          noData: false,
        },
      }
      break
    case GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.polling:
      resultState = {
        ...state,
        competitorTracking: {
          ...state.competitorTracking,
          ...action.payload,
          isLoadingCompetitors: false,
        },
      }
      break
    case GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.success:
      resultState = {
        ...state,
        competitorTracking: {
          ...state.competitorTracking,
          ...action.payload,
        },
      }
      break
    case GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.failed:
      resultState = {
        ...state,
        competitorTracking: {
          ...state.competitorTracking,
          ...action.payload,
          noData: true,
          isLoadingCompetitors: false,
        },
      }
      break
    default:
      return state
  }

  if (!resultState) {
    resultState = {
      ...state,
    }
  }
  return resultState
}

export default dashboardReducer
